module.exports = __webpack_public_path__ + "img/126.8a7e2b9c.png";